import { observer } from "mobx-react";
import { EDITOR_VARIANT, RichTextEditor } from "../../../../components/rich-text-editor/rich-text-editor";
import './email-rich-text-editor.scss';

export interface IEmailTextEditorProps {
    backgroundColor: string;
    minHeight?: number;
    toolbarOffset: number;
    isEditMode: boolean
    content: string;
    onChange: (value: string) => void;
    onEditModeChange: () => void;
}

const editorToolBarHieght = 50;

export const EmailRichTextEditor: React.FC<IEmailTextEditorProps> = observer(({ isEditMode, content, onChange, onEditModeChange, backgroundColor, minHeight, toolbarOffset }) => {

    return (
        <div onClick={(e) => { e.stopPropagation() }} className={"email-editor-content"} style={{ top: toolbarOffset + "px" }}>
            <div style={{ height: `${editorToolBarHieght}px`, display: (isEditMode) ? 'none' : '' }}></div>
            <div style={{ minHeight: minHeight, display: (isEditMode) ? '' : 'none' }} className="shadow-rounded-box">
                <RichTextEditor variant={EDITOR_VARIANT.EMAIL_EDITOR_ONLY} value={content} onChange={onChange} minHeight={minHeight} useVariableSpecialPaste={true}>
                </RichTextEditor>
            </div>
            <div className={`email-viewer-content`} onClick={onEditModeChange} style={{ backgroundColor: backgroundColor, display: (isEditMode) ? 'none' : '' }}>
                <div style={{ minHeight: ((minHeight ?? 0) + 10) }} className="content-viewer" dangerouslySetInnerHTML={{ __html: content }}>
                </div>
            </div>
        </div>
    );
});
